// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ovb3","name":"ConsentHeader_name__29i0d","birthday":"ConsentHeader_birthday__18pbe","skeleton":"ConsentHeader_skeleton__1lY0o"};